import {Component, OnInit, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() title: string;
  @Input() href: string;
  @Input() isBack: boolean;
  @Input() showFltIcon: boolean;
  @Input() readAll: boolean;

  constructor() { }

  ngOnInit() {}

}
